// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const deps = [
  require('ui/web/clientOverview/details').name,
  require('ui/web/clientOverview/ledgers').name,
];

module.exports = angular
  .module('bench.ui.clientOverview', deps)

  .directive('blClientOverview', () => ({
    restrict: 'E',
    scope: {
      clientId: '=',
    },
    bindToController: true,
    template: require('./clientOverview.html'),
    controller() {
      return this;
    },
    controllerAs: 'vm',
  }));
